import { memo, useEffect } from 'react';

import { Attribution, withTransparentErrorBoundary } from '@confluence/error-boundary';
import { type FlagsStateContainer, withFlags } from '@confluence/flags';

import { isExperimentEnabled } from './services/Experimentation';

interface FlyoutMessagingComponentProps {
	flags: FlagsStateContainer;
}

const FlyoutMessagingComponentWrapper = ({ flags }: FlyoutMessagingComponentProps) => {
	const shouldShowFlag = () => {
		// TODO-FLYOUT-MESSAGING: Implement checks
		//   - permanent disabled check
		//	 - last show timestamp check
		return isExperimentEnabled();
	};

	// TODO-FLYOUT-MESSAGING: Implement open notification drawer, use i18n
	const actions = [
		{
			content: 'Open notifications drawer',
			onClick: () => {},
		},
	];

	useEffect(() => {
		// TODO-FLYOUT-MESSAGING: Implement 2 minute delay
		if (shouldShowFlag()) {
			// TODO-FLYOUT-MESSAGING: update placeholders
			void flags.showCustomFlag({
				id: 'flyout-messaging-experiment',
				title: 'PLACEHOLDER TITLE CCNOTIF-4462',
				description: 'PLACEHOLDER DESCRIPTION CCNOTIF-4463',
				actions,
			});
		}
	});

	return null;
};

export const FlyoutMessagingComponent = withTransparentErrorBoundary({
	attribution: Attribution.NOTIFICATIONS,
})(withFlags(memo(FlyoutMessagingComponentWrapper)));
